import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-center" }
const _hoisted_2 = { class: "d-flex align-center my-4" }
const _hoisted_3 = { style: {"font-size":"16px","font-weight":"bold"} }
const _hoisted_4 = { class: "my-4 d-flex" }
const _hoisted_5 = {
  key: 1,
  class: "my-4 d-flex"
}
const _hoisted_6 = {
  class: "sensor-metadata",
  style: {"flex":"1"}
}
const _hoisted_7 = {
  class: "sensor-metadata",
  style: {"flex":"1"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "pa-4",
    style: _normalizeStyle(_ctx.cardStyle)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_img, {
          src: `/img/${_ctx.image}`,
          width: "80%",
          height: "64",
          contain: ""
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_spacer),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.sensorData.lastName) + " " + _toDisplayString(_ctx.sensorData.firstName), 1),
        _createVNode(_component_v_spacer)
      ]),
      (_ctx.isUpdating)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "primary",
            class: "my-8"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_spacer),
        (_ctx.isSleep)
          ? (_openBlock(), _createBlock(_component_v_btn, {
              key: 0,
              color: "#EE6190",
              variant: "flat",
              rounded: "",
              onClick: _ctx.getUp,
              disabled: !_ctx.isStarted || _ctx.isUpdating
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('ui.wakeUp')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]))
          : (_openBlock(), _createBlock(_component_v_btn, {
              key: 1,
              color: "primary",
              variant: "flat",
              rounded: "",
              onClick: _ctx.sleepIn,
              disabled: !_ctx.isStarted || _ctx.isUpdating
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('ui.sleep')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])),
        _createVNode(_component_v_spacer)
      ]),
      (_ctx.isAlerting)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_btn, {
              color: "#EE6190",
              variant: "outlined",
              rounded: "",
              onClick: _ctx.stopAlert
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createTextVNode("mdi-bell-off", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_v_spacer)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_card_actions, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.sensorData.temperature || '-') + " ℃ ", 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.sensorData.respiration || '-') + " 拍 ", 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style"]))
}